import { forwardRef, type SVGProps } from 'react';

export type FigmaCaretRightIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaCaretRightIcon = forwardRef<SVGSVGElement, FigmaCaretRightIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path d="M12 8L8 5V11L12 8Z" fill="currentColor" />
  </svg>
));

FigmaCaretRightIcon.displayName = 'FigmaCaretRightIcon';
